import { User } from '../containers/SignIn/types';

export const clearLocalStorage = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('id');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('profileImageUrl');
    localStorage.removeItem('name');
    localStorage.removeItem('firstname');
    localStorage.removeItem('lastname');
    localStorage.removeItem('signedImageUrl');
};

export const setAccessToken = (token: string) => localStorage.setItem('accessToken', token);
export const getAccessToken = () => localStorage.getItem('accessToken');

export const getLocalStorageData = () => {
    return {
        email: localStorage.getItem('email') ?? '',
        name: localStorage.getItem('name') ?? '',
        firstname: localStorage.getItem('firstname') ?? '',
        lastname: localStorage.getItem('lastname') ?? '',
        id: localStorage.getItem('id') ?? '',
        roleName: localStorage.getItem('roleName') ?? '',
        accessToken: localStorage.getItem('accessToken') ?? '',
        refreshToken: localStorage.getItem('refreshToken') ?? '',
        profileImageUrl: localStorage.getItem('profileImageUrl') ?? '',
        signedImageUrl: localStorage.getItem('signedImageUrl') ?? '',
    };
};
export default getLocalStorageData;

export const setLocalStorageData = (data: User) => {
    localStorage.setItem('email', data.email);
    localStorage.setItem('name', `${data.firstname} ${data.lastname}`);
    localStorage.setItem('firstname', data.firstname);
    localStorage.setItem('lastname', data.lastname);
    localStorage.setItem('id', data.id);
    localStorage.setItem('roleName', data.adminRole.role);
    localStorage.setItem('profileImageUrl', data.profileImageUrl);
    localStorage.setItem('signedImageUrl', data.signedImageUrl);
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
};
